import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Layout from "./Layout";
import { LoaderProvider } from "./context/LoaderProvider.jsx";
function App() {
  return (
    <LoaderProvider>
      <Router>
        <Layout />
      </Router>
    </LoaderProvider>
  );
}

export default App;
